import React from "react";
import { 
  Briefcase, 
  Settings, 
  Palette, 
  Code2, 
  Cloud, 
  Shield, 
  TestTube, 
  Monitor, 
  BarChart3, 
  Users2,
  Building2
} from "lucide-react";
import { Card, CardContent } from "./ui/card";

const Capabilities = () => {
  const capabilities = [
    {
      icon: <Users2 className="capability-icon" />,
      title: "Delivery Management",
      description: "Agile practitioners and Scrum Masters who accelerate delivery in complex digital transformation initiatives.",
      roles: ["Agile Delivery Manager", "Head of Agile Delivery", "Delivery Integration Manager", "Scrum Master", "Technical Delivery Manager", "Service Delivery"]
    },
    {
      icon: <Briefcase className="capability-icon" />,
      title: "Project Management",
      description: "From Program Directors to PMO Coordinators, we place professionals who drive successful project delivery across complex organizational environments.",
      roles: ["Program Director", "Program Manager", "Project Manager", "PMO Manager", "Program Assurance Specialist", "PMO Coordinator", "Portfolio Scheduler", "Project Officer", "Program Coordinator"]
    },
    {
      icon: <Settings className="capability-icon" />,
      title: "Engineering",
      description: "DevSecOps, Site Reliability, and Network Engineers who build and maintain critical infrastructure with security and reliability at the forefront.",
      roles: ["DevSecOps Engineer", "DevOps Engineer", "Site Reliability Engineer", "Network Engineer", "Geospatial Engineer"]
    },
    {
      icon: <Code2 className="capability-icon" />,
      title: "Application Architecture",
      description: "Solutions architects who design scalable, secure applications for complex organizational requirements and regulatory compliance.",
      roles: ["Application Solutions Architect", "Integration Architect", "Application Specialist"]
    },
    {
      icon: <Cloud className="capability-icon" />,
      title: "Cloud Services",
      description: "Azure and multi-cloud specialists who migrate and manage critical workloads with security and compliance at the forefront.",
      roles: ["Cloud Platform Manager", "Azure Cloud Systems Administrator", "Azure Cloud Administrator", "Cloud Administrator", "Cloud Capability Specialist", "Cloud Security Specialist"]
    },
    {
      icon: <Shield className="capability-icon" />,
      title: "Cybersecurity",
      description: "Security professionals who protect critical systems and sensitive data from evolving cyber threats with advanced security measures.",
      roles: ["Cyber Security Analyst", "Cyber Security Architect", "Penetration Tester", "CSOC Analyst", "Cyber Risk Specialist", "Information Security Manager", "Cyber Security Operations Analyst"]
    },
    {
      icon: <TestTube className="capability-icon" />,
      title: "Testing & QA",
      description: "Automation and performance testing experts who ensure applications meet stringent quality, security, and compliance standards.",
      roles: ["Test Automation Engineer", "Automation Test Manager", "Performance Engineer", "Performance Tester", "QA Test Engineer", "Systems Test Engineer", "Test Manager", "Test Lead"]
    },
    {
      icon: <Monitor className="capability-icon" />,
      title: "Development",
      description: "Full-stack developers specializing in enterprise platforms like ServiceNow, Salesforce, along with modern web and API development.",
      roles: ["ServiceNow Developer", "Salesforce Developer", ".NET Developer", "Java Developer", "Python Developer", "Full-stack Developer", "Frontend Developer", "Backend Developer", "API Designer", "Application Developer"]
    },
    {
      icon: <BarChart3 className="capability-icon" />,
      title: "Business Analysis",
      description: "Analysts who bridge business needs with technical solutions in complex transformation projects and system implementations.",
      roles: ["Business Analyst", "Business Solutions Analyst", "Business Needs Analyst", "Business Systems Analyst", "Functional Analyst", "Process Analyst"]
    },
    {
      icon: <Building2 className="capability-icon" />,
      title: "Business Architecture",
      description: "Enterprise and solutions architects who design comprehensive business and technology strategies for organizational transformation.",
      roles: ["Business Solutions Architect", "Enterprise Architect", "Enterprise Business Architect", "Enterprise Solutions Architect", "Domain Architect", "Program Architect"]
    },
    {
      icon: <Palette className="capability-icon" />,
      title: "Interaction Design",
      description: "UX/UI specialists who create intuitive, accessible digital experiences that meet stringent usability and compliance standards.",
      roles: ["UX Designer", "UI Designer", "Experience Designer", "Interactive Designer"]
    }
  ];

  return (
    <section id="capabilities" className="section-padding">
      <div className="container">
        <div className="capabilities-header">
          <h2 className="section-heading centered">Our Capabilities</h2>
          <p className="section-subtext centered">
            We specialize in connecting organizations with IT professionals who excel in complex government, financial, and enterprise environments. Our talent network spans critical technology disciplines, ensuring you find professionals who understand both cutting-edge technology and the unique demands of regulated industries.
          </p>
        </div>
        <div className="capabilities-grid">
          {capabilities.map((capability, index) => (
            <Card key={index} className="capability-card">
              <CardContent className="capability-content">
                <div className="capability-icon-wrapper">
                  {capability.icon}
                </div>
                <h3 className="capability-title">{capability.title}</h3>
                <p className="capability-description">{capability.description}</p>
                <div className="capability-roles">
                  {capability.roles.map((role, roleIndex) => (
                    <span key={roleIndex} className="capability-role-tag">
                      {role}
                    </span>
                  ))}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Capabilities;